import { Button, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LoadingApp from '../../../components/LoadingApp';
import ModalFeedBack from '../../../components/ModalFeedBack';
import { SeguroViagem } from '../../../interfaces/entities/SeguroViagem/SeguroViagem';
import { getSeguroViagem } from '../../../services/ContratoService';
import ContatosSeguroInternacional from './ContatosSeguroInternacional';
import './styles.css';
import { sxBody, sxButton, sxTitle } from './sxProps';
import parse from 'html-react-parser';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import PageTitle from '../../../components/Accessibility/PageTitle';

const SeguroViagemInternacional: React.FC = () => {

  const accessibility = useAccessibility();

  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [seguroViagem, setSeguroViagem] = useState<SeguroViagem>();
  const [modalFeedback, setModalFeedback] = useState<null | {
    icon?: 'error' | 'success' | 'warning', title?: string, textButton?: string, subTitle?: string,
    closeAction: () => void, showButtonModal: boolean, buttonAction?: () => void
  }>(null);

  const fetchSeguroViagem = async () => {
    setLoading(true);
    const response = await getSeguroViagem();
    if (response?.status === 200) {
      setSeguroViagem(response.data);
    } else {
      console.error(response);
      openModalError('Erro', 'Ocorreu um erro ao consultar os detalhes de seguro viagem internacional. Tente novamente em instantes.');
    }
    setLoading(false);
  }

  const openModalError = (title: string, subtitle: string) => {
    setModalFeedback({
      icon: 'error',
      title: title,
      subTitle: subtitle,
      textButton: 'Voltar ao início',
      showButtonModal: true,
      closeAction: () => navigate('/home'),
      buttonAction: () => navigate('/home')
    });
  }


  useEffect(() => {
    fetchSeguroViagem();
  }, []);

  return (
    <>
      <div className='feature-container'>
        <PageTitle text="Seguro viagem internacional" />
        <Typography sx={sxBody}>
          {seguroViagem?.lstDescricao.map((descricao) => (
            <Typography style={accessibility.textStyleAccessibility} letterSpacing={'unset'}>{parse(descricao.descricao)}</Typography>
          ))}
        </Typography>
        <Button
          variant="contained"
          size="large"
          onClick={() => window.open(seguroViagem?.link, '_blank')}
          style={accessibility.buttonStyleAccessibility}
          sx={sxButton}
          aria-label="Ir para o site da GTA – Global Travel Assistance"
        >
          <Typography style={accessibility.buttonTextStyleAccessibility} fontFamily={'UnimedSans-Bold'}>IR PARA O SITE</Typography>
        </Button>
        <ContatosSeguroInternacional lstDescricaoDetalhe={seguroViagem?.lstDescricaoDetalhe} />
      </div>
      <LoadingApp showLoading={loading} text={'Buscando informações de seguro...'} />
      <ModalFeedBack
        showModal={!!modalFeedback}
        handleShowModal={modalFeedback?.closeAction}
        title={modalFeedback?.title as string}
        subTitle={modalFeedback?.subTitle as string}
        icon={modalFeedback?.icon as 'success' | 'error' | 'warning'}
        showButtonModal={modalFeedback?.showButtonModal}
        textButton={modalFeedback?.textButton as string}
        handleButtonModal={modalFeedback?.buttonAction}
      />
    </>
  )
}

export default SeguroViagemInternacional;